const API_PREFIX = '/api';
const DEFAULT_API_BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5050' : '';

export const API_BASE_URL = (process.env.REACT_APP_API_URL || DEFAULT_API_BASE_URL).replace(/\/$/, '');

export const apiUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const apiPath = normalizedPath.startsWith(API_PREFIX) ? normalizedPath : `${API_PREFIX}${normalizedPath}`;
  if (API_BASE_URL) {
    return `${API_BASE_URL}${apiPath}`;
  }
  return apiPath;
};

const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null;
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.split('=').slice(1).join('=')) : null;
};

export async function apiRequest<T>(path: string, options: RequestInit = {}): Promise<T> {
  const method = (options.method || 'GET').toUpperCase();
  let csrfToken = !['GET', 'HEAD', 'OPTIONS'].includes(method) ? getCookie('proteko_csrf') : null;

  if (!csrfToken && !['GET', 'HEAD', 'OPTIONS'].includes(method)) {
    await fetch(apiUrl('/auth/me'), { credentials: 'include' });
    csrfToken = getCookie('proteko_csrf');
  }

  const response = await fetch(apiUrl(path), {
    ...options,
    credentials: 'include',
    headers: {
      ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
      ...(options.headers || {}),
    },
  });

  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json') ? await response.json() : null;

  if (!response.ok) {
    throw new Error(payload?.error || 'Ошибка запроса к серверу');
  }

  return payload as T;
}
